import "antd/dist/antd.css";

import { ButtonOne, People } from "./Buttons";
import { CameraOutlined, ShareAltOutlined } from "@ant-design/icons";
import { Col, Row, Slider, Upload } from "antd";
import React, { useState } from "react";

import Avatar1 from "../assets/avatar-2.png";
import Avatar2 from "../assets/avatar-1.png";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Radium from "radium";
import opis from "../assets/opis-logo.svg";
import superbee from "../assets/superbee.svg";
import { uploadFile } from "../firebase/config";

const ChallengeCard = ({
  img,
  account,
  funded,
  title,
  sponsor,
  reward,
  description,
  requeriments,
  currentFunding,
  fundingGoal,
  addRunes,
  nft,
  image,
  name,
  metadata,
  start,
  end,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [fileImg, setFileImg] = useState();

  function submitChallenge() {
    if (fileImg !== undefined) {
      uploadFile(fileImg, account);
      addRunes();
    }
  }

  const [fileList, setFileList] = useState([]);

  const handlePreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const handleChange = ({ fileList: newFileList }) => {
    if (newFileList[0]?.status === "error") newFileList[0].status = "done";
    setFileList(newFileList);
    setFileImg(newFileList[0]?.originFileObj);
  };

  const uploadButton = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          borderRadius: "100%",
          width: "min-content",
          padding: "24px",
          height: "104x",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          border: "2px dashed white",
          marginBottom: "8px",
        }}
      >
        <CameraOutlined style={{ fontSize: "24px" }} />
        <p style={{ margin: 0 }}>Subir imagen</p>
      </div>

      <p>Permitido: *.jpeg, *.jpg, *.png, *.gif</p>
    </div>
  );

  return (
    <>
      <article style={styles.challengeCard} onClick={() => setModalOpen(true)}>
        <section style={styles.challengeCard.imgContainer}>
          <img
            src={img || image}
            style={
              img ? styles.challengeCard.imgContainer.img : styles.challengeCard.imgContainer.imgNTF
            }
            alt={name ? name : "challenge"}
          />
        </section>

        <section style={styles.challengeCard.info}>
          <div style={styles.challengeCard.info.itemOne}>
            <div style={styles.challengeCard.info.itemOne.text}>
              <p style={styles.challengeCard.info.itemOne.text.p1}>{title || name}</p>
              <p style={styles.challengeCard.info.itemOne.text.p2}>
                Por {sponsor || metadata?.artist}
              </p>
            </div>
            {funded ? (
              <People circleSize={20} imgOne={Avatar1} imgTwo={Avatar2} textThree={"23k+"} />
            ) : nft ? (
              <p style={styles.challengeCard.info.itemOne.suply}>Suply: 10/23</p>
            ) : (
              <ButtonOne text="Donar" />
            )}
          </div>

          <div
            style={nft ? styles.challengeCard.info.itemTwoNFT : styles.challengeCard.info.itemTwo}
          >
            {funded ? (
              <div style={styles.challengeCard.info.reward}>
                <div style={styles.challengeCard.info.itemTwo.text}>
                  <p style={styles.challengeCard.info.itemTwo.text.p}>Gana {reward} OPIS</p>
                </div>
                <ButtonOne text={"Iniciar"} style={{ width: "120px" }} />
              </div>
            ) : nft ? (
              <>
                <p style={styles.challengeCard.info.itemTwoNFT.p}>Precio: 1000 OPIS</p>
                <ButtonOne text="Canjear" style={{ width: "100px" }} />
              </>
            ) : (
              <>
                <div style={styles.challengeCard.info.itemTwo.text}>
                  <p style={styles.challengeCard.info.itemTwo.text.p}>{currentFunding} OPIS</p>
                  <p style={styles.challengeCard.info.itemTwo.text.p}>
                    {(currentFunding / fundingGoal).toFixed(2) * 100}%
                  </p>
                </div>
                <div style={styles.sliderContainer}>
                  <Slider
                    style={styles.sliderContainer.sliderComponent}
                    defaultValue={90}
                    min={0}
                    max={100}
                    handleStyle={styles.sliderContainer.sliderComponent.handleStyle}
                    trackStyle={styles.sliderContainer.sliderComponent.trackStyle}
                  />
                </div>
              </>
            )}
          </div>
        </section>
      </article>

      <Dialog
        onClose={() => setModalOpen(false)}
        open={modalOpen}
        BackdropProps={{ style: styles.dialog.backdrop }}
      >
        <DialogTitle>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <img src={opis} alt="opis" width={100} />
          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
            <img src={superbee} alt={name} width={200} />
            <p style={styles.dialog.title}>{title}</p>
          </div>
        </DialogTitle>
        <DialogContent>
          <section style={styles.dialog.content.firstItem}>
            <p style={styles.dialog.content.firstItem.p}>
              <span style={styles.dialog.content.firstItem.p.span}>Inicio:</span> {start}
            </p>
            <p style={styles.dialog.content.firstItem.p}>
              <span style={styles.dialog.content.firstItem.p.span}>Expiración:</span> {end}
            </p>
          </section>

          <section>
            <div style={{ backgroundImage: `url(${img})`, ...styles.dialog.content.secondItem }}>
              <div style={styles.dialog.content.secondItem.shareContainer}>
                <button style={styles.dialog.content.secondItem.shareContainer.btn}>
                  <ShareAltOutlined style={{ color: "white", fontSize: "30px" }} />
                </button>
                <p style={styles.dialog.content.secondItem.shareContainer.p}>Ganar {reward} OPIS</p>
              </div>

              <div style={styles.dialog.content.secondItem.inputs}>
                <Upload
                  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={handlePreview}
                  onChange={handleChange}
                  onRemove={() => setFileList([])}
                  accept="image/*"
                >
                  {fileList.length === 0 && uploadButton}
                </Upload>

                <input
                  type="text"
                  name="text"
                  placeholder="Descripción ó (URL publicación)"
                  autoComplete="off"
                  className="input-description-challenge"
                  style={styles.dialog.content.secondItem.inputs.input}
                />
              </div>
            </div>
          </section>

          <Row style={styles.dialog.content.thirdItem}>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={18}
              xl={18}
              xxl={18}
              style={styles.dialog.content.thirdItem.col1}
              className="col-scroll-hidden"
            >
              <p
                style={{
                  ...styles.dialog.content.thirdItem.col1.p,
                  fontWeight: 600,
                  marginBottom: "8px",
                }}
              >
                DESCRIPCIÓN
              </p>
              <p style={{ ...styles.dialog.content.thirdItem.col1.p, margin: 0 }}>{description}</p>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={6}
              xl={6}
              xxl={6}
              style={styles.dialog.content.thirdItem.col2}
            >
              <button onClick={submitChallenge} style={styles.dialog.content.thirdItem.col2.btn}>
                Act 1 to Earn {reward} OPIS
              </button>
            </Col>
          </Row>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Radium(ChallengeCard);

const query = {
  xs: "@media (max-width: 576px)",
  sm: "@media (max-width: 767px)",
  md: "@media (max-width: 992px)",
  lg: "@media (max-width: 1200px)",
  xl: "@media (max-width: 1600px)",
};

const styles = {
  challengeCard: {
    display: "flex",
    flexDirection: "column",
    height: "370px",
    width: "350px",
    padding: "16px",
    backgroundColor: "white",
    alignItems: "center",
    borderRadius: "20px",
    imgContainer: {
      display: "flex",
      width: "fit-content",
      height: "212px",
      alignItems: "center",
      justifyContent: "center",
      img: { borderRadius: "18px", width: "100%" },
      imgNTF: { borderRadius: "18px", width: "100%", height: "100%", objectFit: "contain" },
    },

    info: {
      height: "100%",
      width: "100%",
      marginTop: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      itemOne: {
        display: "flex",
        width: "100%",
        alignItems: "center",
        justifyContent: "space-between",
        text: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          p1: { fontSize: "18px", fontWeight: "700", margin: 0 },
          p2: { fontSize: "14px", color: "#A3AED0", margin: 0 },
        },
        suply: { color: "#A3AED0" },
      },
      itemTwo: {
        marginTop: "16px",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        text: {
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "flex-start",
          justifyContent: "space-between",
          p: {
            fontSize: "16px",
            color: "#78D504",
            fontWeight: "800",
            margin: 0,
          },
        },
      },
      itemTwoNFT: {
        marginTop: "16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        p: { margin: 0, color: "rgba(120, 213, 4, 1)", fontSize: "18px", fontWeight: 600 },
      },

      reward: {
        display: "flex",
        flexDirection: "row",
        height: "20px",
        alignItems: "center",
        justifyContent: "center",
      },
    },
  },

  sliderContainer: {
    width: "100%",
    sliderComponent: {
      handleStyle: {
        backgroundColor: "#78D504",
        borderColor: "white",
      },
      trackStyle: { backgroundColor: "#78D504", height: "6px" },
    },
  },
  dialog: {
    backdrop: { backgroundColor: "rgba(229, 247, 211, 0.9)" },
    title: {
      fontSize: "50px",
      textAlign: "center",
      margin: 0,
      color: "#2B3674",
      [query.xs]: { fontSize: "40px" },
    },
    content: {
      firstItem: {
        display: "flex",
        justifyContent: "space-around",
        p: { fontSize: "16px", marginBottom: "8px", color: "#A3AED0", span: { fontWeight: 600 } },
      },
      secondItem: {
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        borderRadius: "30px 30px 0 0",
        backgroundPosition: "center",
        padding: "8px",
        shareContainer: {
          display: "flex",
          alignItems: "center",
          btn: {
            backgroundColor: "rgba(120, 213, 4, 1)",
            padding: "12px",
            borderRadius: "100%",
            border: "4px solid white",
            zIndex: 2,
          },
          p: {
            margin: "0 0 0 -20px",
            padding: "2px 8px 2px 24px",
            color: "white",
            backgroundColor: "rgba(120, 213, 4, 1)",
            fontSize: "16px",
            borderRadius: "12px",
            border: "2px solid white",
          },
        },
        inputs: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          input: {
            backgroundColor: "rgba(24, 43, 1, 0.4)",
            border: "2px solid white",
            borderRadius: "10px",
            color: "white",
            padding: "4px 16px",
            fontSize: "16px",
            maxWidth: "300px",
            width: "100%",
            margin: "0 8px 8px 0",
          },
        },
      },
      thirdItem: {
        marginBottom: "32px",
        backgroundColor: "rgba(120, 213, 4, 1)",
        borderRadius: "0 0 30px 30px",
        col1: {
          padding: "8px 16px",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          borderRadius: "0 0 30px 30px",
          p: { fontSize: "16px", color: "#2B3674" },
          maxHeight: "165px",
          overflowY: "scroll",
        },
        col2: {
          padding: "8px 16px",
          btn: {
            border: "none",
            backgroundColor: "transparent",
            width: "100%",
            height: "100%",
            fontSize: "28px",
            textAlign: "left",
            fontWeight: 600,
            color: "white",
            [query.md]: { textAlign: "center" },
          },
        },
      },
    },
  },
  buttonContainer: {
    display: "flex",
    backgroundColor: "#78D504",
    borderRadius: "70px",
    border: 0,
    color: "white",
    height: "34px",
    fontSize: "14px",
    fontWeight: "600",
    width: "80px",
    alignItems: "center",
    justifyContent: "center",
  },
};
